module.exports = __webpack_public_path__ + "media/images/weather/41_night_g-860b56222d91349e63153f45e18f16b5.png";